/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Dispatch, SetStateAction, useState } from 'react'
import DatePicker from 'react-datepicker';
type Props = {
  SetSearch?:Dispatch<SetStateAction<any>>
  
}

export function Dropdown4({SetSearch}: Props) {
  const [date, setDate] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  var now = new Date();
  const maxDate = new Date(now.getFullYear(), now.getMonth()+ 1).toISOString().slice(0, 7); 
  return (
    <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
      <div className='px-7 py-5'>
        <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
      </div>

      <div className='separator border-gray-200'></div>

      <div className='px-7 py-5'>
        <div className='mb-10'>
          <label className='form-label fw-bold'>Date:</label>
          <div>
          {
              navigator.userAgent.indexOf("Chrome") !== -1 ? <input
              type='month'
              className='form-control'
              max={maxDate}
              onChange={(e) => {
                setDate(e.target.value)
              }}
              value={date}
          /> : <DatePicker
                  selected={startDate}
                  onChange={(dates: any) => {
                    setStartDate(dates)
                    navigator.userAgent.indexOf("Firefox") !== -1 && SetSearch!(dates.toISOString().slice(0, 7))
                  }}
                  maxDate={new Date(now.getFullYear(), now.getMonth()+ 1)}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
              />
          }
          </div>
        </div>
        {
          navigator.userAgent.indexOf("Chrome") !== -1 && <div className='d-flex justify-content-end'>
          <button
            type='reset'
            className='btn btn-sm btn-light btn-active-light-primary me-2'
            data-kt-menu-dismiss='true'
            onClick={() => {
              setDate('')
            }}
          >
            Reset
          </button>
          <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={() => SetSearch!(date)}>
            Apply
          </button>
        </div>
        }
        
      </div>
    </div>
  )
}
